var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/eventlog.ts
import { A } from "@adornis/base/env-info.js";
import { BaseQLClient } from "@adornis/baseql/client/baseqlClient.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { context } from "@adornis/baseql/server/context.js";
import { selectionSet } from "@adornis/baseql/utils/queryGeneration.js";
import { routingState } from "@adornis/router/client/routing-state.js";
import "mongodb";
import { Analytics } from "./analytics.js";
if (A.isServer) {
  const eventlog = getRawCollection("eventlog");
  eventlog.then((eventlog2) => {
    eventlog2.createIndex({ createdAt: -1, _class: 1 });
    eventlog2.createIndex({ _class: 1, createdAt: -1 });
    eventlog2.createIndex({ _class: 1, createdAt: 1 });
    eventlog2.createIndex({ _class: 1, createdAt: -1, userID: 1 });
    eventlog2.createIndex({ _class: 1, userID: 1 });
    eventlog2.createIndex({ _class: 1, route: 1 });
    eventlog2.createIndex({ createdAt: -1 });
    eventlog2.createIndex({ createdAt: -1, userID: 1 });
    eventlog2.createIndex({ userID: 1 });
  });
}
var EventLog = class extends MongoEntity {
  static get allFields() {
    return selectionSet(() => this, 2);
  }
  // Gets set from addEventlog mutation
  constructor(doc) {
    super(doc);
  }
  static async afterCreate(entity, result) {
    const allSubClassesOfAnalytics = Analytics.metaTreeNode.children.map(
      (child) => child.type()
    );
    await Promise.all(allSubClassesOfAnalytics.map((subClass) => subClass.createQueueJob(entity)));
  }
  async save() {
    const id = await super.save();
    this.sendToAnalytics();
    return id;
  }
  sendToAnalytics() {
  }
};
EventLog._class = "EventLog";
EventLog._collectionName = "eventlog";
__decorateClass([
  Field(() => String, {
    default: (v) => v ?? (A.isServer && !context.serverContext ? context.userID : null)
  })
], EventLog.prototype, "userID", 2);
__decorateClass([
  Field(() => Date, { default: (v) => v ?? /* @__PURE__ */ new Date() })
], EventLog.prototype, "createdAt", 2);
__decorateClass([
  Field(() => String, {
    default: (v) => v ?? (A.isClient ? routingState.path : "cant_get_route_on_server")
  })
], EventLog.prototype, "route", 2);
__decorateClass([
  Field(() => String, { default: (v) => v ?? (A.isClient ? navigator.userAgent : null) })
], EventLog.prototype, "userAgent", 2);
__decorateClass([
  Field(() => String, { default: (v) => v ?? (A.isClient ? navigator.platform : null) })
], EventLog.prototype, "platform", 2);
__decorateClass([
  Field(() => String, { default: (v) => v ?? (A.isClient ? navigator.language : null) })
], EventLog.prototype, "language", 2);
__decorateClass([
  Field(() => String, { default: (v) => v ?? (A.isClient ? navigator.vendor || navigator.appCodeName : null) })
], EventLog.prototype, "vendor", 2);
__decorateClass([
  Field(() => String, {
    default: (v) => v ?? (A.isClient ? BaseQLClient.sessionID : context.serverContext ? null : context.sessionID)
  })
], EventLog.prototype, "clientSession", 2);
EventLog = __decorateClass([
  Entity()
], EventLog);
if (A.isClient && !A.isServiceWorker) {
  window.EventLog = EventLog;
}
export {
  EventLog
};
